import dynamic from 'next/dynamic';

const UploadImageV3 = dynamic(() => import('./UploadImageV3/UploadImageV3'));
const UploadARNMImageV2 = dynamic(() =>
  import('./UploadARNMImageV2/UploadARNMImageV2')
);
const FileDropZone = dynamic(() => import('./FileDropZone/FileDropZone'));
const FileList = dynamic(() => import('./FileList/FileList'));
const FileItem = dynamic(() => import('./FileList/FileItem'));
const UploadCSV = dynamic(() => import('./UploadCSV/UploadCSV'));
const UploadInput = dynamic(() => import('./UploadInput/UploadInput'));
const WebCam = dynamic(() => import('./WebCam/WebCam'));
const UploadDocumentV3 = dynamic(() =>
  import('./UploadDocumentV3/UploadDocumentV3')
);
const UploadARNMDocumentV2 = dynamic(() =>
  import('./UploadARNMDocumentV2/UploadARNMDocumentV2')
);
const CatalogMedia = dynamic(() => import('./CatalogMedia/CatalogMedia'));
const Image = dynamic(() => import('./Image/Image'));

export {
  UploadImageV3,
  UploadARNMImageV2,
  FileDropZone,
  FileList,
  FileItem,
  UploadCSV,
  UploadInput,
  WebCam,
  UploadDocumentV3,
  UploadARNMDocumentV2,
  CatalogMedia,
  Image,
};
